import http from '../../../http-common';

export function requestLoadGenericParameters() {
    return http.get('/GenericParameters');
}

export function requestSaveGenericParameter(parameter) {
    return http.post('/GenericParameters', parameter);
}
